export const TOKEN = 'TOKEN';
export const DELETE_TOKEN = 'DELETE_TOKEN';

export function changeToken(name, value){
    return { type: name, value };
}